package com.seanshubin.vote.contract

import kotlinx.serialization.Serializable

@Serializable
data class TransferElectionOwnershipRequest(
    val newOwnerName: String,
)
